import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  Link,
  makeStyles,
} from "@material-ui/core";
import { UpdatedValue } from "@ofqual/portal-activity-feed/activityfeed/UpdatedValue";
import { ActivityDialogProps, ChangeActivityBody, FieldChange } from "../types";
import { fieldLabels } from "../../../sections/fieldLabels";
const useStyles = makeStyles((theme) => ({
  changeDetails: {
    padding: 15,
  },
  actions: {
    padding: 15,
  },
}));

export const UpdatedDialog: React.FC<ActivityDialogProps> = ({
  activity,
  onClose,
}) => {
  const classes = useStyles();

  const body: ChangeActivityBody = JSON.parse(activity.activityMetaData);

  return (
    <Dialog
      open={true}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      data-test="updated-dialog"
    >
      <DialogTitle data-test="activity-title">
        {activity.activityTitle}
      </DialogTitle>
      <Divider />
      <DialogContent>
        {body.changes.map((change) => (
          <div key={change.field}>
            <h3 data-test="activity-field-title">
              {fieldLabels[change.field]}
            </h3>
            <div className={classes.changeDetails}>
              <Grid container spacing={3}>
                <Grid item>
                  <b>Old value:</b>
                </Grid>
                <Grid item md={10}>
                  {renderChange(change.field, change.oldValue, fieldLabels)}
                </Grid>
                <Grid item>
                  <b>New value:</b>
                </Grid>
                <Grid item md={10}>
                  {renderChange(change.field, change.newValue, fieldLabels)}
                </Grid>
              </Grid>
            </div>
          </div>
        ))}
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Link
          component="button"
          onClick={onClose}
          data-test="close-change-button"
        >
          Close
        </Link>
      </DialogActions>
    </Dialog>
  );
};

const renderChange = (
  field: keyof typeof fieldLabels,
  change: string | null,
  labels: { [key: string]: string }
) => {
  if (!change) {
    return null;
  }
  switch (field) {
    case "content":
    case "videoEmbed":
      return <div dangerouslySetInnerHTML={{ __html: change }} />;
    default:
      return <UpdatedValue value={change} fieldLabels={labels} />;
  }
};
